import { apiGet } from './httpClient'

export async function getLatestMonthSummary(signal, params = {}) {
  return apiGet('/eventos/summary/', { signal, query: params })
}

export async function listPersonSummary(params = {}, signal) {
  return apiGet('/eventos/person-summary/', { signal, query: params })
}

export async function getDistincts(params = {}, signal) {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // Para cada valor no array, adiciona o parâmetro repetido
      value.forEach(val => {
        if (val !== undefined && val !== null && val !== '') {
          searchParams.append(key, String(val).trim())
        }
      })
    } else if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value))
    }
  })

  const queryString = searchParams.toString()
  const url = queryString ? `/eventos/distincts/?${queryString}` : '/eventos/distincts/'

  return apiGet(url, { signal })
}

export async function getTrends(params = {}, signal) {
  // Usa suporte a query do httpClient
  return apiGet('/eventos/trends/', { signal, query: params })
}

export async function getDimensionValues(name, signal, params = {}) {
  const query = {
    ...(params || {}),
    name,
    page_size: params.page_size || 5000
  }
  return apiGet('/dimensions/', { signal, query })
}
